import React from "react"

import Image from "next/image"
import PropTypes from "prop-types"

const StarRating = ({ rating, star, alt = "star", wrapperClass = "" }) => {
  return (
    <div className={wrapperClass + " flex"}>
      {Array.from({ length: rating }, (_, index) => (
        <Image
          key={index}
          src={star.src}
          alt={alt}
          height={star.height}
          width={star.width}
          loading="lazy"
        />
      ))}
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  star: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    src: PropTypes.string,
  }),
  alt: PropTypes.string,
  wrapperClass: PropTypes.string,
}

export default StarRating
